module.exports = __webpack_public_path__ + "img/131ne.046499e7.svg";